import { IconWithCountButton } from "@clipboard-health/ui-components";
import { useDeleteCommentReaction } from "@src/appV2/redesign/Workplace/Review/api/useDeleteCommentReaction";
import { usePostCommentReaction } from "@src/appV2/redesign/Workplace/Review/api/usePostCommentReaction";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";

import { Reaction } from "../types";

interface WorkplaceReviewCommentLikesButtonProps {
  isLiked: boolean;
  count: number;
  onLikeChanged: (comment: WorkplaceCommentType) => void;
  workplaceId: string;
  commentId: string;
}

export function WorkplaceReviewCommentLikesButton(props: WorkplaceReviewCommentLikesButtonProps) {
  const { isLiked, count, onLikeChanged, workplaceId, commentId } = props;

  const { mutate: postCommentReaction } = usePostCommentReaction(
    { workplaceId, commentId },
    {
      onSuccess: (data) => {
        onLikeChanged(data.data);
      },
    }
  );

  const { mutate: deleteCommentReaction } = useDeleteCommentReaction(
    { workplaceId, commentId },
    {
      onSuccess: (data) => {
        onLikeChanged(data.data);
      },
    }
  );

  return (
    <IconWithCountButton
      isActive={isLiked}
      count={count}
      baseIconType="like-outlined"
      activeIconType="like-filled"
      onClick={(event) => {
        event.stopPropagation();

        if (isLiked) {
          deleteCommentReaction();
        } else {
          postCommentReaction({ reaction: Reaction.LIKE });
        }
      }}
    />
  );
}
